import getComponent from '../utils/get-component'

export default getComponent('link color-animate blue hover-light-blue', 'a')
